import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import {isEmpty} from "lodash";
import {ReportOrderToGoogleTagManager} from "./ReportOrderToGoogleTagManager";
import ReportOrderToGoogleAnalytics4 from "./ReportOrderToGoogleAnalytics4";

export default function ReportToGoogle({
  order, orderedItems, groupCollection,
  googleTagManager = {disabled: true},
  debugReporting = false,
  ...props
}) {

  const useGtm = (!isEmpty(googleTagManager)) &&
    (!googleTagManager.disabled) &&
    googleTagManager.tagId && true;

  const InnerComponent = useGtm ? ReportOrderToGoogleTagManager :
    ReportOrderToGoogleAnalytics4;

  return <InnerComponent
    order={order}
    orderedItems={orderedItems}
    groupCollection={groupCollection}
    googleTagManager={googleTagManager}
    debugReporting={debugReporting}
  />
}
